import { BlogValueCta } from './BlogValueCta';
import { Callout, type CalloutProps } from './Callout';

/**
 * The labels a post uses for its opening summary box. `TL;DR`, `Key findings`,
 * and `The short version` are the three conventions already in `content/blog`,
 * and `scripts/content_check.py` requires a changed post to carry one of them.
 */
const SUMMARY_TITLES = new Set(['tl;dr', 'key findings', 'the short version']);

const isSummary = (title?: string) => title !== undefined && SUMMARY_TITLES.has(title.trim().toLowerCase());

/**
 * `Callout` as the posts see it, with the product card under the summary one.
 *
 * The CTA is attached here rather than written into each `.mdx` on purpose. A
 * new post cannot add a summary and forget the CTA, and - the reason it is this
 * shape and not a `<Summary>` tag the posts opt into - no post file has to
 * change to get it. Editing 15 shipped posts would have put them back through
 * the changed-content quality gate, which then demands they meet a floor written
 * after they were published: FAQ length, a limitations section, CTA counts. That
 * is editorial work on ranking content, not a side effect a CTA should cause.
 *
 * Every other callout in a post renders exactly as before.
 */
export const SummaryCallout = (props: CalloutProps) => (
  <>
    <Callout {...props} />
    {isSummary(props.title) ? <BlogValueCta /> : null}
  </>
);
